import { alertKind, alertLevel, type AlertKind, type AlertLevel } from "../../../shared/alerts";
import type { WeatherAlert } from "../../../shared/models";
import type { IconName } from "../../ui/Icon";

export const KIND_ICON: Record<AlertKind, IconName> = {
  fire: "flame",
  tornado: "wind",
  storm: "bolt",
  flood: "waves",
  winter: "cloud",
  wind: "wind",
  heat: "thermo",
  cold: "thermo",
  air: "eye",
  dust: "wind",
  civil: "alert",
  other: "alert",
};

/** CSS tone for an alert: fire gets its own ember palette; then by level. */
export function toneOf(a: WeatherAlert): "fire" | AlertLevel {
  return alertKind(a.event) === "fire" ? "fire" : alertLevel(a);
}

export function untilText(a: WeatherAlert, timeZone: string, h24: boolean): string | null {
  if (!a.ends) return null;
  const end = new Date(a.ends);
  const sameDay = new Intl.DateTimeFormat("en-CA", { timeZone }).format(end) === new Intl.DateTimeFormat("en-CA", { timeZone }).format(new Date());
  const time = new Intl.DateTimeFormat("en-US", { timeZone, hour: "numeric", minute: "2-digit", hourCycle: h24 ? "h23" : "h12" }).format(end);
  return sameDay ? `until ${time}` : `until ${new Intl.DateTimeFormat("en-US", { timeZone, weekday: "short" }).format(end)} ${time}`;
}
